var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectanglePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0664062,
    width: 28.0088,
    height: 28.0088,
    rx: 5.39929,
    fill: "#ECEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0694 7.82845C13.6408 7.82845 13.2933 8.17594 13.2933 8.6046V19.4032C13.2933 19.8318 13.6408 20.1793 14.0694 20.1793C14.4981 20.1793 14.8456 19.8318 14.8456 19.4032V8.6046C14.8456 8.17594 14.4981 7.82845 14.0694 7.82845Z",
    fill: "#3E63FF",
    stroke: "#3E63FF",
    strokeWidth: 0.202474,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67101 13.2269C8.24235 13.2269 7.89486 13.5744 7.89486 14.003C7.89486 14.4317 8.24235 14.7792 8.67101 14.7792H19.4696C19.8982 14.7792 20.2457 14.4317 20.2457 14.003C20.2457 13.5744 19.8982 13.2269 19.4696 13.2269H8.67101Z",
    fill: "#3E63FF",
    stroke: "#3E63FF",
    strokeWidth: 0.202474,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectanglePlus);
export default __webpack_public_path__ + "static/media/rectangle-plus.4256e5df485079cafd3ed71de7de494c.svg";
export { ForwardRef as ReactComponent };